import { useMemo } from 'react'
import { useAuth } from 'torqcloud-ui'

import { useOrganization } from '@/contexts/OrganizationContext'
import { canViewOrganizationAuditLog } from '@/utils/organizationAuditLogAccess'

export default function useOrganizationAuditLogAccess() {
  const { organizations } = useAuth()
  const { currentOrganizationId } = useOrganization()

  return useMemo(() => {
    const currentOrganization = organizations.find(organization => organization.organization_id === currentOrganizationId) ?? null
    return { canViewOrganizationAuditLog: canViewOrganizationAuditLog(currentOrganization) }
  }, [currentOrganizationId, organizations])
}
